module.exports = __webpack_public_path__ + "static/img/H3_0.4c985fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/H3_0.png
// module id = L9wx
// module chunks = 0